export enum MatchType {
  Exact = 0,
  Manual = 1,
  Possible = 2,
  None = 3,
}
